<template>
  <button
    class="action-button"
    :class="{ '-loading': internalState === 'loading', '-done': internalState === 'done' }"
    @click="pressed"
  >
    <span class="text"><i :class="glyph"></i>{{ text }}</span>
    <span class="loading-spinner -white"></span>
    <span class="done"></span>
  </button>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      require: true,
      default: ""
    },
    state: {
      type: String,
      default: "normal"
    },
     glyph: {
       type: String,
       default: ""
     }
   },

   emits: ['pressed', 'revertState'],

   data() {
    return {
      internalState: "normal"
    };
  },

  watch: {
    state() {
      switch (this.internalState) {
        case "loading":
          setTimeout(() => {
            this.internalState = this.state;
            this.revertState();
          }, 300);
          break;
        case "done":
          setTimeout(() => {
            this.internalState = this.state;
            this.revertState();
          }, 1500);
          break;
        default:
          this.internalState = this.state;
          this.revertState();
      }
    }
  },

  methods: {
    pressed(ev) {
      ev.preventDefault();
      ev.stopPropagation();

      if (this.state !== "normal") return;
      this.$emit("pressed");
    },

    revertState() {
      if (this.internalState === "done") {
        // Switch back to normal after 2 seconds
        setTimeout(() => {
          this.internalState = "normal";
          this.$emit("revertState");
        }, 2000);
      }
    }
  }
};
</script>
